<template>
  <div class="dashboard-actions" :class="controls ? 'dashboard-actions--with-controls' : ''" style="max-width: 50rem;">
    <div class="dashboard-actions__controls" v-if="controls">
      <grab-control @grabstart="(e) => $emit('grabstart', e)" @grabend="(e) => $emit('grabend', e)"></grab-control>
      <kebab-menu>
        <action-link icon-left="icon-settings" size="small" class="mb-1" @click="$emit('configure')" v-if="editable">{{ $t('widgets.Dashboard.configure') }}</action-link>
        <action-link icon-left="icon-trash" size="small" @click="$emit('delete')">{{ $t('widgets.Dashboard.remove') }}</action-link>
      </kebab-menu>
    </div>

    <div class="dashboard-actions__inner">
      <require-action></require-action>
      <add-order v-if="ShowOrderButton"></add-order>
      <response-qr-code v-if="ShowResponseQr"></response-qr-code>
      <qr-check v-if="ShowQrCheck"></qr-check>
      <ref-link v-if="ShowGoldShopLink"></ref-link>
    </div>
  </div>
</template>

<script>
import RequireAction from './RequireAction'
import ResponseQrCode from './ResponseQrCode'
import QrCheck from './QrCheck'
import RefLink from './RefLink'
import AddOrder from './AddOrder'

import ActionLink from '@/ui/controls/ActionLink'
import KebabMenu from '@/ui/controls/KebabMenu'
import GrabControl from '@/ui/controls/GrabControl'

import {
  ShowGoldShopLink,
  ShowResponseQr,
  ShowQrCheck,
  ShowDashboardActions,
  ShowOrderButton
} from '@/mixins/displayRules'

export default {
  mixins: [
    ShowGoldShopLink,
    ShowResponseQr,
    ShowQrCheck,
    ShowDashboardActions,
    ShowOrderButton
  ],

  components: {
    AddOrder,
    KebabMenu,
    ActionLink,
    GrabControl,
    RequireAction,
    ResponseQrCode,
    RefLink,
    QrCheck
  },

  props: {
    editable: {
      type: Boolean,
      default: false
    },

    controls: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
  .dashboard-actions {
    position: relative;

    &__controls {
      position: absolute;
      right: 1rem;
      top: 1rem;
      z-index: 1;

      & > * {
        font-size: 1.8rem!important;

        & > a {
          color: $color-black;
        }

        & > a:link {
          font-size: 1.8rem!important;
          color: $color-black;
        }
      }
    }

    &--with-controls .dashboard-actions {
      &__inner {
        padding-top: 4rem;
      }
    }
  }
</style>
